import React from 'react'

const MenuNumber = ({number, status}) => {
  return (
      <span className={"badge badge-" + status + " badge-circle"}>{number}</span>
  );
};
export default MenuNumber
